import { createSlice } from "@reduxjs/toolkit";
import { faqHelpsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const faqHelpsSlice = createSlice({
  name: "faqHelps",
  initialState: data,
  reducers: {
    faqHelpsSlice(state) {
      state.isLoading = false;
    },
    faqHelpsSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    faqHelpsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    faqHelpsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const faqHelpsHandler = () => async (dispatch: any) => {
  try {
    dispatch(faqHelpsAction.faqHelpsSlice());
    const response: any = await faqHelpsAPI();
    dispatch(faqHelpsAction.faqHelpsSliceSuccess(response));
  } catch (e: any) {
    dispatch(faqHelpsAction.faqHelpsSliceFailure(e?.response?.data?.message));
    dispatch(faqHelpsAction.faqHelpsSliceReset());
  }
};
export default faqHelpsSlice.reducer;
export const faqHelpsAction = faqHelpsSlice.actions;
